import { render, staticRenderFns } from "./Chats.vue?vue&type=template&id=61844fbc&scoped=true&"
import script from "./Chats.vue?vue&type=script&lang=js&"
export * from "./Chats.vue?vue&type=script&lang=js&"
import style0 from "./Chats.vue?vue&type=style&index=0&id=61844fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61844fbc",
  null
  
)

export default component.exports